import { EXTENSIONS } from 'probonio-shared-ui/registry';
import { ExtensionBuilder } from 'probonio-shared-ui/registry/extension-definition';
import { BenefitActivationDialogExtensionInterface } from '../../../extension/interface/benefit-activation-dialog.extension.interface';
import { BenefitColumnsExtensionInterface } from '../../../extension/interface/benefit-columns.extension.interface';
import { BenefitMetadataExtensionInterface } from '../../../extension/interface/benefit-metadata.extension.interface';
import { BenefitNavigationExtensionInterface } from '../../../extension/interface/benefit-navigation.extension.interface';
import { ATLunchBenefitActivationDialogExtension } from './extension/at-lunch-benefit-activation-dialog.extension';
import { ATLunchBenefitColumnsExtension } from './extension/at-lunch-benefit-columns.extension';
import { ATLunchBenefitMetadataExtension } from './extension/at-lunch-benefit-metadata.extension';
import { ATLunchBenefitNavigationExtension } from './extension/at-lunch-benefit-navigation.extension';

EXTENSIONS.registerExtension(
  new ExtensionBuilder('atLunch')
    .add(BenefitMetadataExtensionInterface, new ATLunchBenefitMetadataExtension())
    .add(BenefitNavigationExtensionInterface, new ATLunchBenefitNavigationExtension())
    .add(BenefitColumnsExtensionInterface, new ATLunchBenefitColumnsExtension())
    .add(BenefitActivationDialogExtensionInterface, new ATLunchBenefitActivationDialogExtension())
    .build(),
);
